
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.857 6.903C12.389 4.023 11.286 2 10.002 2 8.717 2 7.614 4.023 7.146 6.903h5.711zM6.904 10c0 .716.039 1.403.107 2.065h5.978a20.202 20.202 0 000-4.13H7.011A20.214 20.214 0 006.904 10zm10.477-3.097a8.018 8.018 0 00-5.098-4.568c.787 1.09 1.329 2.733 1.613 4.568h3.485zM7.717 2.335a8.013 8.013 0 00-5.094 4.568h3.484c.281-1.835.823-3.477 1.61-4.568zm10.009 5.6h-3.701c.068.678.107 1.371.107 2.065s-.04 1.387-.107 2.065h3.697A7.928 7.928 0 0018 10c0-.716-.1-1.403-.274-2.065zM5.872 10c0-.694.038-1.387.106-2.065h-3.7A8.07 8.07 0 002 10c0 .716.103 1.403.277 2.065h3.698A21.838 21.838 0 015.872 10zm1.274 3.097C7.614 15.977 8.717 18 10.002 18c1.284 0 2.387-2.023 2.855-4.903h-5.71zm5.14 4.568a8.025 8.025 0 005.098-4.568h-3.485c-.284 1.835-.826 3.477-1.613 4.568zm-9.663-4.568a8.018 8.018 0 005.098 4.568c-.788-1.09-1.33-2.733-1.614-4.568H2.623z","fill":"#191F2D"}})])
          )
        }
      }
    